import { RootState } from '@store/index';

export const selectBreadcrumbs = (state: RootState) =>
  state.Breadcrumb.breadcrumbs;
